import axios from "axios";

const { REACT_APP_MY_ENV } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_MY_ENV,
});

// Handle user session
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 409) {
      sessionStorage.removeItem("token_store");
      window.location.href = "/auth/sign-in";
    }
    return Promise.reject(error);
  }
);

export function getPaymentHistory(endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/monetization/payments/history",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getPayments() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/payments",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
